export default {
  id: 'getting-started',
  title: 'Početak rada',
  icon: 'mdi-rocket-launch',
  show: true,
  order: 1,
  children: [
    {
      id: 'what-is-aikasa',
      title: 'Što je AI Kasa?',
      icon: 'mdi-information',
      show: true,
      order: 1,
      content: () => `
        <h2>Što je AI Kasa?</h2>
        <p>
          AI Kasa je suvremeni cloud-based sustav za upravljanje prodajom,
          namijenjen svim vrstama poslovnih subjekata - od malih trgovina do
          velikih lanaca, restorana i ugostiteljskih objekata.
        </p>

        <h3 class="mt-4">Glavne funkcionalnosti</h3>
        <div class="features-grid">
          <div class="feature-card">
            <i class="mdi mdi-cash-register" style="font-size: 48px; color: #3989C9;"></i>
            <h4>Blagajne</h4>
            <p>Brzo izdavanje računa s fiskalizacijom</p>
          </div>
          <div class="feature-card">
            <i class="mdi mdi-package-variant" style="font-size: 48px; color: #3989C9;"></i>
            <h4>Artikli</h4>
            <p>Upravljanje proizvodima i cijenama</p>
          </div>
          <div class="feature-card">
            <i class="mdi mdi-warehouse" style="font-size: 48px; color: #3989C9;"></i>
            <h4>Skladište</h4>
            <p>Praćenje zaliha i dokumenata</p>
          </div>
          <div class="feature-card">
            <i class="mdi mdi-chart-bar" style="font-size: 48px; color: #3989C9;"></i>
            <h4>Izvještaji</h4>
            <p>Detaljni financijski i prodajni izvještaji</p>
          </div>
        </div>
      `
    },
    {
      id: 'login',
      title: 'Prijava u sustav',
      icon: 'mdi-login',
      show: true,
      order: 2,
      content: () => `
        <h2>Prijava u sustav</h2>
        <p>
          Za prijavu u AI Kasa sustav potreban vam je email i lozinka
          koje ste dobili prilikom registracije.
        </p>

        <h3 class="mt-4">Korak po korak</h3>
        <ol>
          <li>Otvorite web preglednik i idite na: <code>https://aduro.aikasa.app</code></li>
          <li>Unesite svoj email u polje "Email"</li>
          <li>Unesite svoju lozinku u polje "Lozinka"</li>
          <li>Kliknite gumb "Prijavi se"</li>
        </ol>

        <div class="warning-box mt-4">
          <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
          <strong>Zaboravljena lozinka?</strong> Kliknite na "Zaboravili ste lozinku?"
          link ispod gumba za prijavu.
        </div>

        <h3 class="mt-4">Česta pitanja</h3>
        <details>
          <summary>Ne mogu se prijaviti - što sad?</summary>
          <p>
            Provjerite jeste li upisali ispravan email i lozinku.
            Pazite na velika i mala slova. Ako i dalje ne možete,
            koristite opciju za resetiranje lozinke.
          </p>
        </details>
      `
    },
    {
      id: 'interface-overview',
      title: 'Pregled sučelja',
      icon: 'mdi-monitor-dashboard',
      show: true,
      order: 3,
      content: () => `
        <h2 id="overview">Pregled sučelja AI Kasa</h2>
        <p>
          AI Kasa sučelje je dizajnirano za brzu i intuitivnu upotrebu.
          Aplikacija se sastoji od nekoliko glavnih dijelova koji omogućavaju
          jednostavnu navigaciju i rad sa svim funkcionalnostima.
        </p>

        <h3 class="mt-4">Glavni dijelovi sučelja</h3>

        <h4 class="mt-3">1. Gornji navigacijski bar</h4>
        <p>Na vrhu aplikacije nalazi se glavni navigacijski bar koji sadrži:</p>
        <ul>
          <li><strong>Logo i naziv aplikacije</strong> - AI Kasa</li>
          <li><strong>Odabir firme</strong> - Dropdown za odabir aktivne firme (ako imate pristup više firmi)</li>
          <li><strong>Notifikacije</strong> - Ikona zvona za obavijesti</li>
          <li><strong>Korisnički profil</strong> - Avatar s dropdown menuom za postavke i odjavu</li>
        </ul>

        <h4 class="mt-3">2. Lijevi navigacijski meni</h4>
        <p>Glavni meni s ikonama i linkovima na sve module:</p>
        <table class="info-table">
          <thead>
            <tr>
              <th>Ikona</th>
              <th>Modul</th>
              <th>Opis</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><i class="mdi mdi-view-dashboard"></i></td>
              <td><strong>Dashboard</strong></td>
              <td>Pregled ključnih podataka i statistika</td>
            </tr>
            <tr>
              <td><i class="mdi mdi-cash-register"></i></td>
              <td><strong>Blagajne</strong></td>
              <td>Upravljanje blagajnama i rad na blagajni</td>
            </tr>
            <tr>
              <td><i class="mdi mdi-package-variant"></i></td>
              <td><strong>Artikli</strong></td>
              <td>Upravljanje artiklima i cijenikom</td>
            </tr>
            <tr>
              <td><i class="mdi mdi-warehouse"></i></td>
              <td><strong>Skladište</strong></td>
              <td>Skladišno poslovanje i evidencija</td>
            </tr>
            <tr>
              <td><i class="mdi mdi-receipt-text"></i></td>
              <td><strong>Računi</strong></td>
              <td>Pregled svih izdanih računa</td>
            </tr>
            <tr>
              <td><i class="mdi mdi-chart-bar"></i></td>
              <td><strong>Izvještaji</strong></td>
              <td>Prodajni i financijski izvještaji</td>
            </tr>
            <tr>
              <td><i class="mdi mdi-cog"></i></td>
              <td><strong>Postavke</strong></td>
              <td>Konfiguracija sustava</td>
            </tr>
          </tbody>
        </table>

        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Savjet:</strong> Meni možete otvoriti ili zatvoriti klikom na hamburger ikonu <i class="mdi mdi-menu"></i> u gornjem lijevom kutu.
          </div>
        </div>

        <h4 class="mt-3">3. Radna površina (Main Content Area)</h4>
        <p>Središnji dio aplikacije gdje se prikazuje sadržaj odabranog modula:</p>
        <ul>
          <li><strong>Breadcrumbs</strong> - Navigacijska putanja (npr. "Dashboard › Blagajne › Pregled")</li>
          <li><strong>Naslov stranice</strong> - Velika zaglavna sekcija sa nazivom trenutne stranice</li>
          <li><strong>Action buttons</strong> - Gumbi za glavne akcije (npr. "Dodaj novi", "Spremi", "Izvoz")</li>
          <li><strong>Tablice/Liste</strong> - Prikaz podataka u tabličnom obliku</li>
          <li><strong>Forme</strong> - Unos i uređivanje podataka</li>
        </ul>

        <h4 class="mt-3">4. Status bar (donji bar)</h4>
        <p>Na nekim stranicama, posebno na blagajni, prikazuje se status bar s informacijama:</p>
        <ul>
          <li>Status smjene (otvorena/zatvorena)</li>
          <li>Trenutno stanje blagajne</li>
          <li>Aktivni korisnik</li>
        </ul>

        <h3 class="mt-4">Tipovi komponenti</h3>

        <h4 class="mt-3">Tablice s podacima</h4>
        <p>Većina stranica prikazuje podatke u tabličnom obliku sa sljedećim funkcijama:</p>
        <ul>
          <li><strong>Sortiranje</strong> - Klik na zaglavlje stupca sortira podatke</li>
          <li><strong>Filtriranje</strong> - Polja za pretragu iznad ili ispod zaglavlja</li>
          <li><strong>Paginacija</strong> - Navigacija kroz stranice (10, 25, 50, 100 zapisa po stranici)</li>
          <li><strong>Akcije</strong> - Ikone za uređivanje, brisanje ili druge akcije u zadnjem stupcu</li>
        </ul>

        <h4 class="mt-3">Forme</h4>
        <p>Forme za unos podataka sadrže različite tipove polja:</p>
        <ul>
          <li><strong>Tekstualna polja</strong> - Za unos teksta (ime, adresa, napomena)</li>
          <li><strong>Brojčana polja</strong> - Za unos brojeva (cijena, količina)</li>
          <li><strong>Dropdown liste</strong> - Za odabir iz predefiniranih opcija</li>
          <li><strong>Checkboxes</strong> - Za da/ne opcije</li>
          <li><strong>Date pickers</strong> - Za odabir datuma</li>
          <li><strong>Upload polja</strong> - Za upload datoteka ili slika</li>
        </ul>

        <div class="warning-box">
          <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Obavezna polja:</strong> Polja označena sa <span style="color: red;">*</span> su obavezna i moraju biti popunjena prije spremanja.
          </div>
        </div>

        <h3 class="mt-4">Boje i oznake</h3>
        <p>Aplikacija koristi konzistentnu paletuku boja za lakše razumijevanje:</p>
        <ul>
          <li><span class="status-chip blue">PLAVA</span> - Informacije, aktivno</li>
          <li><span class="status-chip green">ZELENA</span> - Uspješno, fiskalizirano, OK</li>
          <li><span class="status-chip orange">NARANČASTA</span> - Upozorenje, pending</li>
          <li><span class="status-chip red">CRVENA</span> - Greška, stornirano, neaktivno</li>
          <li><span class="status-chip grey">SIVA</span> - Neutralno, draft</li>
        </ul>

        <h3 class="mt-4">Responzivnost</h3>
        <p>AI Kasa aplikacija je responzivna i radi na različitim uređajima:</p>
        <ul>
          <li><strong>Desktop</strong> - Puni prikaz sa svim funkcionalnostima</li>
          <li><strong>Tablet</strong> - Prilagođeni prikaz, meni se može sakriti</li>
          <li><strong>Mobilni</strong> - Pojednostavljen prikaz za osnovne funkcije</li>
        </ul>

        <div class="success-box">
          <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Savjet:</strong> Za rad na blagajni preporučujemo korištenje desktop računala ili tableta za najbolje korisničko iskustvo.
          </div>
        </div>

        <h2 id="tips" class="mt-6">Savjeti za rad</h2>
        <ul>
          <li><strong>Breadcrumbs navigacija</strong> - Koristite breadcrumbs za brzi povratak na prethodnu stranicu</li>
          <li><strong>Tipkovničke prečice</strong> - Većina akcija podržava tipkovničke prečice (vidi "Caffe template → Keyboard shortcuts")</li>
          <li><strong>Pretraga</strong> - Koristite Ctrl+F (Cmd+F na Mac-u) za pretragu unutar tablica</li>
          <li><strong>Osvježi stranicu</strong> - F5 osvježava podatke na trenutnoj stranici</li>
        </ul>
      `
    },
    {
      id: 'navigation',
      title: 'Osnovna navigacija',
      icon: 'mdi-navigation',
      show: true,
      order: 4,
      content: () => `
        <h2 id="navigation">Osnovna navigacija</h2>
        <p>
          AI Kasa nudi nekoliko načina navigacije kroz aplikaciju kako bi omogućila
          brz i intuitivan pristup svim funkcionalnostima sustava.
        </p>

        <h3 class="mt-4">Načini navigacije</h3>

        <h4 class="mt-3">1. Lijevi navigacijski meni</h4>
        <p>Glavni način navigacije je kroz lijevi meni koji sadrži sve module:</p>
        <ol>
          <li>Kliknite na <strong>ikonu modula</strong> u lijevom meniju</li>
          <li>Otvorit će se glavni prikaz modula</li>
          <li>Za podstranice, meni često ima podmenu koji se otvara klikom na strelicu</li>
        </ol>

        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Savjet:</strong> Držite mišem preko ikone u meniju da vidite naziv modula ako je meni zatvoren (collapsed).
          </div>
        </div>

        <h4 class="mt-3">2. Breadcrumbs (navigacijska putanja)</h4>
        <p>Na vrhu svake stranice nalazi se breadcrumbs koji pokazuje vašu trenutnu lokaciju:</p>
        <ul>
          <li>Primjer: <code>Dashboard › Blagajne › Pregled blagajne</code></li>
          <li>Kliknite na bilo koji dio breadcrumbs-a da se vratite na tu stranicu</li>
          <li>Breadcrumbs automatski prati vašu navigacijsku povijest</li>
        </ul>

        <h4 class="mt-3">3. Akcijski gumbi i linkovi</h4>
        <p>Na stranicama se nalaze različiti akcijski gumbi:</p>
        <table class="info-table">
          <thead>
            <tr>
              <th>Gumb</th>
              <th>Akcija</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><button style="background: linear-gradient(135deg, rgba(0, 179, 190, 0.9) 0%, rgba(57, 137, 201, 0.85) 50%, rgba(97, 84, 164, 0.9) 100%); color: white; padding: 8px 16px; border: none; border-radius: 8px; font-weight: 600; cursor: pointer;">+ Dodaj novi</button></td>
              <td>Otvara formu za kreiranje novog zapisa</td>
            </tr>
            <tr>
              <td><i class="mdi mdi-pencil"></i> Uredi</td>
              <td>Otvara formu za uređivanje postojećeg zapisa</td>
            </tr>
            <tr>
              <td><i class="mdi mdi-eye"></i> Pregledaj</td>
              <td>Otvara detaljan prikaz zapisa (read-only)</td>
            </tr>
            <tr>
              <td><i class="mdi mdi-delete"></i> Obriši</td>
              <td>Briše zapis (obično uz potvrdu)</td>
            </tr>
          </tbody>
        </table>

        <h4 class="mt-3">4. Povratak natrag</h4>
        <p>Nekoliko načina za povratak na prethodnu stranicu:</p>
        <ul>
          <li><strong>Browser "Back" gumb</strong> - Koristite strelicu natrag u browseru</li>
          <li><strong>Breadcrumbs</strong> - Kliknite na prethodni dio putanje</li>
          <li><strong>"Natrag" gumb</strong> - Na nekim stranicama postoji gumb "Natrag" ili "Odustani"</li>
          <li><strong>ESC tipka</strong> - Zatvara dialoge i modale</li>
        </ul>

        <h3 class="mt-4">Navigacija po modulima</h3>

        <h4 class="mt-3">Dashboard (Nadzorna ploča)</h4>
        <ul>
          <li>Glavni pregled sustava</li>
          <li>Kartice sa ključnim metrikama (klikabilne - vode na detaljne stranice)</li>
          <li>Grafovi i dijagrami</li>
        </ul>

        <h4 class="mt-3">Blagajne</h4>
        <ul>
          <li><strong>Pregled blagajna</strong> - Lista svih blagajna</li>
          <li><strong>Otvori blagajnu</strong> - Klik na gumb "Otvori" ili kartica blagajne</li>
          <li><strong>Rad na blagajni</strong> - Puni ekran za izdavanje računa</li>
        </ul>

        <h4 class="mt-3">Artikli i Cjenik</h4>
        <ul>
          <li><strong>Artikli</strong> - Lista svih artikala</li>
          <li><strong>Cjenik</strong> - Lista artikala na cjeniku za prodajno mjesto</li>
          <li><strong>Kategorije</strong> - Upravljanje kategorijama artikala</li>
        </ul>

        <h4 class="mt-3">Skladište</h4>
        <ul>
          <li><strong>Stanje skladišta</strong> - Trenutne količine</li>
          <li><strong>Dokumenti</strong> - Primke, izdatnice, međuskladišnice</li>
          <li><strong>Dobavljači</strong> - Lista dobavljača</li>
          <li><strong>Inventura</strong> - Popis stanja</li>
        </ul>

        <h4 class="mt-3">Računi</h4>
        <ul>
          <li><strong>Svi računi</strong> - Lista svih izdanih računa</li>
          <li><strong>Filtriranje</strong> - Pretraga po datumu, broju, klijentu</li>
          <li><strong>Detaljni prikaz</strong> - Klik na račun otvara detalje</li>
        </ul>

        <h4 class="mt-3">Izvještaji</h4>
        <ul>
          <li>Odaberite tip izvještaja iz menija</li>
          <li>Postavite filter (datum, prodajno mjesto, itd.)</li>
          <li>Kliknite "Prikaži" ili "Generiraj"</li>
          <li>Izvoz u PDF/Excel ako je dostupno</li>
        </ul>

        <h4 class="mt-3">Postavke</h4>
        <ul>
          <li><strong>Firma</strong> - Osnovni podaci, certifikati</li>
          <li><strong>Korisnici</strong> - Upravljanje korisnicima i privilegijama</li>
          <li><strong>Prodajna mjesta</strong> - Konfiguracija lokacija</li>
          <li><strong>Integracije</strong> - Pisači, POS uređaji</li>
        </ul>

        <h3 class="mt-4">Pretraga</h3>
        <p>Većina tablica ima funkciju pretrage:</p>
        <ol>
          <li>Unesite ključnu riječ u polje "Pretraži..."</li>
          <li>Sustav automatski filtrira rezultate dok tipkate</li>
          <li>Kliknite <i class="mdi mdi-close"></i> da očistite filter</li>
        </ol>

        <div class="warning-box">
          <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Napomena:</strong> Pretraga obično pretražuje više polja odjednom (npr. naziv, šifra, barcode).
          </div>
        </div>

        <h3 class="mt-4">Odabir firme</h3>
        <p>Ako imate pristup više firmi:</p>
        <ol>
          <li>Kliknite na dropdown sa nazivom firme u gornjem baru</li>
          <li>Odaberite željenu firmu iz liste</li>
          <li>Aplikacija se osvježava i prikazuje podatke odabrane firme</li>
        </ol>

        <div class="success-box">
          <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Savjet:</strong> Uvijek provjerite koja je firma trenutno aktivna prije nego kreirate nove zapise ili izdajete račune!
          </div>
        </div>

        <h2 id="tips" class="mt-6">Savjeti za brzu navigaciju</h2>
        <ul>
          <li><strong>Favoriti</strong> - Često korištene stranice dodajte u browser bookmarks</li>
          <li><strong>Tipkovničke prečice</strong> - Koristite prečice za brže kretanje (vidi "Caffe template → Keyboard shortcuts")</li>
          <li><strong>Multi-tab</strong> - Otvorite više tab-ova u browseru za rad na više stvari paralelno</li>
          <li><strong>Refresh (F5)</strong> - Osvježite stranicu ako ne vidite najnovije podatke</li>
        </ul>
      `
    }
  ]
}
